export class WebAgentService {

    async fetchWebAgentVersion(webAgentServerUrl: string, token: string) {
        const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        };

        return fetch(`${webAgentServerUrl}/api/v2/info/bundle`, { headers })
            .then(response => response.json())
            .then((result: any) => {
                return result.webAgent.version;
            })
            .catch(() => {
                return undefined;
            });
    }
}
